import type { CollectionItem } from '@/hooks/useCollection';
import { getCardPrice } from '@/lib/card-prices';

/** Unit (per-copy) USD price for a collection item, preferring the real print price. */
export function collectionUnitPrice(item: CollectionItem): number {
  const printPrice = item.print?.price_usd != null ? Number(item.print.price_usd) : null;
  if (printPrice != null && !Number.isNaN(printPrice)) return printPrice;
  if (item.card) return getCardPrice(item.card).mid;
  return 0;
}

export function collectionLineValue(item: CollectionItem): number {
  return collectionUnitPrice(item) * (item.quantity || 1);
}
